import { connect } from 'react-redux'
import editDocumentSourceSelector from './editDocumentSourceSelector'
import { sagaActions as rootSagaActions } from 'store/sagas'
import EditDocumentSource from './EditDocumentSource'

export default connect(
  editDocumentSourceSelector,
  {
    requestChangeDocumentSourceName: rootSagaActions.requestChangeDocumentSourceName
  }
)(EditDocumentSource)

